import styled from "styled-components";
import Slider from "react-slick";
import { ReactComponent as Beds } from "../../../assets/icons/bed.svg";
import { ReactComponent as Bath } from "../../../assets/icons/bath.svg";
import { ReactComponent as Car } from "../../../assets/icons/car.svg";
import { ReactComponent as Ruler } from "../../../assets/icons/ruler.svg";
import { ReactComponent as Calndar } from "../../../assets/icons/calendar.svg";
import { ReactComponent as Galary } from "../../../assets/icons/galary.svg";
import { ReactComponent as Map } from "../../../assets/icons/map.svg";
import { ReactComponent as Location } from "../../../assets/icons/location_user.svg";
import { ReactComponent as Share } from "../../../assets/icons/share.svg";
import { ReactComponent as Heart } from "../../../assets/icons/heart.svg";
export const Wrap = styled.div`
  padding: 80px 200px;
  .allImg {
    min-width: 100%;
    height: 700px;
  }
  .slick-img-wrap {
    margin-bottom: 80px;
  }
  .selected {
    width: 100px;
  }
`;
export const SliderSlick = styled(Slider)`
  .slick-arrow .slick-prev {
    left: 0px !important;
    ::before {
      color: red !important;
    }
  }
  .slick-arrow .slick-next {
  }

  .slick-dots {
    display: flex !important;
    align-items: center !important;
    bottom: 0 !important;
    height: 120px !important;
    li {
      flex: 1;
    }
    li img {
      width: 150px;
    }
  }
`;

Wrap.Slider = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;
Wrap.Galary = styled(Galary)``;
Wrap.Map = styled(Map)``;
Wrap.Location = styled(Location)``;

Wrap.Icons = styled.div`
  position: absolute;
  top: 4%;
  right: 1%;
  z-index: 10;
  display: flex;
  align-items: center;
`;
Wrap.Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  margin: ${({ mr }) => (mr ? mr : "")};
  border-radius: 50%;
  height: 50px;
  background-color: #0d263b;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 80px;
`;
Details.Title = styled.h1`
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #0d263b;
`;
Details.Desc = styled.h1`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  margin-top: 10px;
`;

Details.Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 73px;
  height: 23px;
  margin-left: 10px;
  font-weight: 600;
  font-size: 10px;
  line-height: 13px;
  cursor: pointer;
  border-radius: 3px;
  color: #fff;
  background: ${({ background }) => (background ? background : "#0061DF")};
`;

Details.House = styled.div`
  display: flex;
  align-items: center;
  width: 500px;
  justify-content: space-between;
  span {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #696969;
  }
  margin-top: 30px;
`;

export const Icons = styled.div`
  display: flex;
  align-items: center;
`;

Icons.Beds = styled(Beds)`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`;
Icons.Bath = styled(Bath)`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`;
Icons.Car = styled(Car)`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`;
Icons.Ruler = styled(Ruler)`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`;
Icons.Calndar = styled(Calndar)`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`;

Icons.Prices = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-top: 70px;
`;

Icons.Wrap = styled.div`
  display: flex;
  align-items: center;
  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
`;

Icons.Share = styled(Share)`
  width: 30px;
  background: #f6f8f9;
  height: 30px;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  margin-right: 10px;
`;
Icons.Heart = styled(Heart)`
  width: 30px;
  background: #f6f8f9;
  height: 30px;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  margin-right: 10px;
  path {
    fill: #696969;
  }
`;

Icons.Price = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-decoration-line: line-through;
    color: #696969;
  }
  h1 {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #0d263b;
    margin-left: 10px;
  }
`;

Icons.Name = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  margin-left: auto;
  margin-top: 10px;
`;

export const FullData = styled.div`
  display: flex;
  margin-top: 50px;
`;

FullData.Description = styled.div`
  display: flex;
  flex-direction: column;
`;

FullData.Contact = styled.div`
  display: flex;
  flex-direction: column;
  width: 330px;
  height: 702px;
  margin-left: auto;
  background: #ffffff;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
`;

FullData.Title = styled.h1`
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #0d263b;
`;

FullData.Info = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
  border-bottom: 1.3px solid #e6e9ec;
  padding-bottom: 50px;
  margin-bottom: 50px;
`;
FullData.Location = styled.div`
  display: grid;
  border-bottom: 1.3px solid #e6e9ec;
  padding-bottom: 50px;
  margin-bottom: 50px;
  grid-template-columns: 1fr 1fr 1fr;
  div {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #0d263b;
    margin-top: 20px;
  }
  div span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #696969;
    margin-left: 10px;
  }
`;

export const User = styled.div`
  display: flex;
  flex-direction: column;
  margin: 30px;
  .label {
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    color: #0d263b;
    margin-bottom: 8px;
  }
  textarea {
    border: none;
    border-bottom: 2px solid #0061df;
    outline: none;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #0d263b;
  }
`;
User.Wrap = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;
User.Img = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #090761;
`;
User.Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;
User.Name = styled.h2`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;
  padding: 0;
  margin: 0;
`;
User.Tel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
  padding: 0;
  margin: 0;
`;
User.View = styled.p`
  font-weight: 400;
  font-size: 14px;
  padding: 0;
  margin: 0;
  line-height: 24px;
  text-decoration-line: underline;
  color: #0061df;
`;

User.Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  margin: 20px 0 10px 0;
  border: none;
  padding-bottom: 10px;
  outline: none;
  border-bottom: 1px solid #e6e9ec;
`;

User.Submit = styled.div`
  display: flex;
  margin-top: 30px;
  input {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    cursor: pointer;
  }
  label {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #696969;
  }
`;

User.Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 270px;
  height: 55px;
  background: ${({ bg }) => (bg ? bg : "#0061df")};
  color: ${({ color }) => (color ? color : "#fff")};
  border-radius: 3px;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  border: 1px solid #0061df;
  border-color: ${({ bcolor }) => (bcolor ? bcolor : "#0061df")};
  cursor: pointer;
  margin-top: ${({ top }) => (top ? top : "30px")};
`;
